<template>
	<div id="wallpaper">
		<!--下拉框-->
		<article id="selectHandle">
			<img src="../images/icon/line4.png" />
			<p class="selectType" style="margin: 0 0 -20px 0;">
				<span v-text="selectCategory.name"></span>
				<img src="../images/icon/arrow_b_d.png" style="vertical-align: middle;" />
			</p>
			<img src="../images/icon/line4.png" />
			<ul class="selectNav">
				<li v-for="item in wallpaperCategoryList" @click="selectClick(item)">
					<p v-text="item.name"></p>
					<img src="../images/icon/line.png" />
				</li>
			</ul>
		</article>
		<!--壁纸列表-->
		<article id="wallpaperWarpper">
			<div class="wallpaperItem" v-for="(item,index) in wallpaperDataList" @click="wallpaperClick(index)">
				<img :src="item.thumbnailUrl" :data-bigImg="item.imageUrl" style="width: 100%;vertical-align: middle;" />
			</div>
			<ul id="pagination">
				<li>
					<a @click="jumpPge('homePage')">首页</a>
				</li>
				<li>
					<a @click="jumpPge('prevPage')">上一页</a>
				</li>
				<li>
					<span style="line-height: 27px;"><i v-text="currentPage">0</i><i>/</i><i v-text="totalPage">0</i></span>
				</li>
				<li>
					<a @click="jumpPge('nextPage')">下一页</a>
				</li>
				<li style="border: none;" @click="jumpPge('lastPage')">
					<a>尾页</a>
				</li>
			</ul>
		</article>
		<!--轮播图-->
		<transition name="fade">
			<article v-show="isShowSwiper" class="swiper-container wallpaperSwiper">
				<img class="closeBtn" src="../images/icon/close.png" @click="isShowSwiper=!isShowSwiper" />
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in wallpaperDataList">
						<img class="swiper-lazy" :data-src="item.imageUrl" />
						<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
						<!--<div style="line-height: 30px;color: white;position: absolute;top: 90px;right: 30px;border: 1px solid gray;border-radius: 10px;background: rgba(0,0,0,0.5);padding: 0 10px;cursor: pointer;">下载原图</div>-->
					</div>
				</div>
				<img class="preBtn" src="../images/icon/ban_pre.png" style="left: 10%;" @click="preNextClick('pre')" />
				<img class="nextBtn" src="../images/icon/ban_next.png" style="right: 10%;" @click="preNextClick('next')" />
			</article>
		</transition>
	</div>

</template>

<script>
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	var _this;
	export default {
		name: 'wallpaper',
		data() {
			return {
				wallpaperDataList: [], // 壁纸单个分类数据列表
				wallpaperCategoryList: [], // 壁纸所有分类
				wallpaperSwiperObj: {},
				selectCategory: {}, // 当前选中的壁纸分类
				isShowSwiper: false,
				currentPage: 1, // 当前页码
				totalPage: 1, // 总页码
				pageSize: 30, // 一页显示壁纸数量
				swiperArray: [],
			}
		},
		//监听
		watch: {
			wallpaperDataList: function() {
				setTimeout(function() {
					_this.initSwiper();
				}, 100)
			},
			currentPage: function() {
				this.wallpaperDataList = [];
			},
			selectCategory: function(e) {
				this.wallpaperDataList = [];
			},
			isShowSwiper:function(e){
				if(e){
					$('html').css('overflow','hidden');
				}else{
					$('html').css('overflow','auto');
				}
			}
		},
		//实例加载完成后
		created() {},

		//页面完成以后
		mounted: function() {
			_this = this;
			this.requestWallpaperCategories()

			// 壁纸类型下拉框展示-隐藏
			$('#selectHandle').hover(function(e) {
				$('#selectHandle ul').css('display', 'block');
			}, function(e) {
				$('#selectHandle ul').css('display', 'none');
			})
		},

		//事件处理
		methods: {
			// 页码跳转
			jumpPge: function(name) {
				if(name == 'homePage') { // 首页
					if(this.currentPage == 1) return;
					this.wallpaperDataList = [];
					this.currentPage = 1;
					this.requestWallpaperList(0);
				} else if(name == 'prevPage') { // 上一页
					if(this.currentPage == 1) return;
					if(this.currentPage <= 1) {
						this.currentPage = 1;
						this.requestWallpaperList(0)
					} else {
						this.currentPage -= 1;
						this.requestWallpaperList(this.currentPage * this.pageSize - this.pageSize);
					}
				} else if(name == 'nextPage') { // 下一页
					if(this.currentPage == this.totalPage) return;
					this.wallpaperDataList = [];
					if(this.currentPage >= this.totalPage) {
						this.currentPage = this.totalPage;
						this.requestWallpaperList((this.currentPage - 1) * this.pageSize)
					} else {
						this.requestWallpaperList(this.currentPage * this.pageSize);
						this.currentPage += 1;
					}
				} else if(name == 'lastPage') { // 尾页
					if(this.currentPage == this.totalPage) return;
					this.wallpaperDataList = [];
					this.currentPage = this.totalPage;
					this.requestWallpaperList((this.currentPage - 1) * this.pageSize)
				}
			},
			// 轮播图初始化
			initSwiper: function() {
				function initSize() { // 大小初始化
					var sH = $('.wallpaperSwiper').css('height');
					var sW = $('.wallpaperSwiper').css('width');
					$('div.swiper-slide').css({
						'line-height': sH,
						'height': sH,
						'width': sW
					})
					$('div.swiper-slide>img').css({
						'max-width': sW,
						'max-height': sH
					})
				};
				this.wallpaperSwiperObj = new Swiper('.wallpaperSwiper', {
					lazy: {
						loadPrevNext: true,
						loadPrevNextAmount: 30,
					},

					observer: true,
					observeParents: true,
					lazyLoading: true,
					loop: true,
					delay: 4000,
					speed: 1000,
					on: {
						init: function() {
							initSize()
						},
						resize: function() {
							initSize()
						},
					},

				});
			},
			// 壁纸点击预览
			wallpaperClick: function(index) {
				this.wallpaperSwiperObj.slideToLoop(index, 1000, false); //切换到第一个slide，速度为1秒
				this.isShowSwiper = !this.isShowSwiper;
				console.log('aaa:', this.wallpaperDataList)
			},
			// 轮播图上一页-下一页
			preNextClick: function(name) {
				$('div.swiper-wrapper').css('transition-duration', '0ms'); // 解决不能切换上下页的问题
				name == 'pre' ? this.wallpaperSwiperObj.slidePrev() : this.wallpaperSwiperObj.slideNext();
			},
			// 下拉框选中事件
			selectClick: function(item) {
				this.selectCategory = item;
				$('#selectHandle ul').css('display', 'none');
				this.requestWallpaperList(0);
			},
			//-------------------------------------------------------------------------------------------------------------------
			// 请求壁纸分类列表
			requestWallpaperCategories: function() {
				this.request.get({
					url: '/edg/category/wallpaper',
					params: {
						'condition': 'status=0',
						'exclude': 'wallpapers',
					},
					callback: function(d) {
						if(d.data == undefined || d.data.length == 0) {
							$('#pagination').css('display', 'none');
							return;
						}
						this.wallpaperCategoryList = d.data;
						if(this.wallpaperCategoryList.length >= 15) {
							$('#selectHandle .selectNav').css('overflow-y', 'scroll');
						}
						this.selectCategory = this.wallpaperCategoryList[0];

						this.requestWallpaperList(0);

						console.log('获取壁纸类别41：', this.wallpaperCategoryList, d)
					}.bind(this)
				})

			},
			// 获取指定id分类下壁纸列表
			requestWallpaperList: function(offset) {
				this.request.get({
					url: '/edg/wallpaper',
					params: {
						'size': this.pageSize,
						'offset': offset ? offset : 0,
						'condition': 'Category__Id=' + this.selectCategory.id,
					},
					callback: function(d) {
						if(d.data == undefined || d.data.length == 0) {
							this.wallpaperDataList = [];
							$('#pagination').css('display', 'none');
							return;
						};
						$('#pagination').css('display', 'block');
						this.wallpaperDataList = d.data;
						this.totalPage = Math.ceil(d.total / this.pageSize);
						console.log('获取壁纸列表45：', this.wallpaperDataList, d)
					}.bind(this)
				})
			}
		},

	}
</script>

<style scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s
	}
	
	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
	
	#wallpaper {
		min-height: 600px;
		width: 60%;
		min-width: 1080px;
		margin: 0 auto;
		margin-top: 70px;
	}
	
	#wallpaperWarpper {
		display: flex;
		flex-wrap: wrap;
		margin-top: 50px;
	}
	
	img.closeBtn {
		position: absolute;
		right: 20px;
		top: 20px;
		cursor: pointer;
		z-index: 99;
		zoom: 1.2;
	}
	img.closeBtn:hover{
		zoom: 1.4;
		right: 15px;
		top: 15px;
	}
	
	#selectHandle .selectNav {
		position: absolute;
		width: 100%;
		font-size: 18px;
		cursor: pointer;
		color: #333;
		background-color: white;
		display: none;
		border: 1px solid #ccc;
		box-sizing: border-box;
		padding: 10px 0;
		margin-top: -8px;
		box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
	}
	
	#selectHandle .selectNav li {
		height: 40px;
		position: relative;
	}
	
	#selectHandle .selectNav p {
		margin: 0;
		position: absolute;
		width: 100%;
		line-height: 32px;
		height: 32px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	#selectHandle .selectNav img {
		width: 80%;
		height: 1px;
		position: absolute;
		top: 30px;
		left: 25px;
	}
	
	#selectHandle .selectNav>li:hover {
		color: #428bca;
	}
	
	.swiper-container {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
	}
	
	.swiper-wrapper {
		position: relative;
		text-align: center;
	}
	
	.swiper-slide>img {
		vertical-align: middle;
	}
	
	.preBtn,.nextBtn {
		position: fixed;
		top: 50%;
		z-index: 999;
	}
	.preBtn:hover,.nextBtn:hover{
		background-color: grey;
		cursor: pointer;
	}
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s
	}
	
	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
	
	#wallpaper {
		min-height: 600px;
		width: 60%;
		margin: 0 auto;
		margin-top: 70px;
	}
	
	#wallpaperWarpper {
		display: flex;
		flex-wrap: wrap;
		margin-top: 50px;
	}
	
	#wallpaperWarpper .wallpaperItem {
		width: 150px;
		margin: 10px;
		height: 150px;
		line-height: 150px;
		background-color: black;
		cursor: pointer;
		overflow: hidden;
	}
	
	#selectHandle {
		font-size: 30px;
		color: #010101;
		cursor: pointer;
		width: 258px;
		display: inline-block;
		text-align: center;
		position: relative;
	}
	
	#selectHandle .selectNav {
		position: absolute;
		width: 100%;
		font-size: 18px;
		cursor: pointer;
		color: #333;
		background-color: white;
		display: none;
		border: 1px solid #ccc;
		box-sizing: border-box;
		padding: 10px 0;
		margin-top: -8px;
		box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
		min-height: 150px;
	}
	
	#pagination {
		width: 100%;
		text-align: center;
		font-size: 0;
		padding: 30px 0;
	}
	
	#pagination li {
		display: inline-block;
		font-size: 20px;
		padding: 3px 10px;
		border-right: 1px solid #0f71bb;
		-ms-user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
	}
	
	#pagination li a {
		cursor: pointer;
	}
	
	#pagination li:hover {
		background: #ddd;
	}
</style>


// WEBPACK FOOTER //
// src/components/wallpaper.vue